export default __webpack_public_path__ + "static/media/preloader.c4f1cbd8.svg";